var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"top-white-box"}),_c('div',{staticClass:"top-gray-box daily-deals-gray-box"},[_vm._m(0),_c('div',{staticClass:"daily-deals-date"},[_vm._v(_vm._s(_vm.dailyDate))])]),_c('Deals',{attrs:{"date":_vm.dailyDate}}),_c('app-modal')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Daily Deals")])])
}]

export { render, staticRenderFns }